var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('script',{attrs:{"id":"editor","type":"text/plain"}}),_vm._v(" "),(_vm.isupload)?_c('Upload',{attrs:{"config":{total:9},"isupload":_vm.isupload},on:{"returnImgs":_vm.returnImgsFunc}},[_vm._v("上传图片")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c929e626","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UE.vue
// module id = null
// module chunks = 